import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';

const STATUS_CONFIG = {
  abierta: { label: 'Abierta', className: 'bg-blue-100 text-blue-700 border-blue-200' },
  parcial: { label: 'Parcial', className: 'bg-amber-100 text-amber-700 border-amber-200' },
  cerrada: { label: 'Cerrada', className: 'bg-gray-100 text-gray-600 border-gray-200' },
  con_diferencia: { label: 'Con Diferencia', className: 'bg-red-100 text-red-700 border-red-200' },
  incompleta: { label: 'Incompleta', className: 'bg-amber-100 text-amber-700 border-amber-200' },
  completa: { label: 'Completa', className: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  en_bodega: { label: 'En Bodega', className: 'bg-teal-100 text-teal-700 border-teal-200' },
  salida_camion: { label: 'Salida Camión', className: 'bg-purple-100 text-purple-700 border-purple-200' },
  general: { label: 'General', className: 'bg-gray-100 text-gray-600 border-gray-200' },
  especial: { label: 'Especial', className: 'bg-amber-100 text-amber-700 border-amber-200' },
  ledezma: { label: 'Ledezma', className: 'bg-blue-100 text-blue-700 border-blue-200' },
  mario: { label: 'Mario', className: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  admin: { label: 'Admin', className: 'bg-red-100 text-red-700 border-red-200' },
  encargada: { label: 'Encargada', className: 'bg-teal-100 text-teal-700 border-teal-200' },
  supervisor: { label: 'Supervisor', className: 'bg-amber-100 text-amber-700 border-amber-200' },
  consulta: { label: 'Consulta', className: 'bg-gray-100 text-gray-600 border-gray-200' },
};

export function StatusBadge({ status, className }) {
  const config = STATUS_CONFIG[status] || { label: status, className: 'bg-gray-100 text-gray-600' };
  return (
    <Badge
      variant="outline"
      className={cn('font-medium text-xs px-2 py-0.5 border', config.className, className)}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </Badge>
  );
}
